import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store'
import { MdField } from 'vue-material/dist/components'
import VueMaterial from 'vue-material'

/* https://jossef.github.io/material-design-icons-iconfont/ */
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-material/dist/vue-material.css'
import 'vue-material/dist/theme/default.css'
import './stylesheets/theme.scss'
require('typeface-roboto')

Vue.config.productionTip = false

Vue.use(VueMaterial)

// Dirty fix for https://github.com/vuematerial/vue-material/issues/2285
// Remove this if it's finally fixed in a future version
Vue.use(MdField)
Vue.component('MdFile', Vue.options.components.MdFile.extend({
  methods: {
    isInvalidValue: function isInvalidValue () {
      return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput
    }
  }
}))
Vue.component('MdSelect', Vue.options.components.MdSelect.extend({
  methods: {
    isInvalidValue: function isInvalidValue () {
      return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput
    }
  }
}))

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js